import api from 'Application/api/api';
import convertToNullableValues from 'Common/utils/convertToNullableValues';
import adaptInvoiceRequestData from './adapters/adaptInvoiceRequestData';

const patchInvoice = async (signal, invoiceId, values) => {
	const nullableValues = convertToNullableValues(values, ['number', 'status', 'currency']);
	const response = await api.patch(`/invoices/${invoiceId}`, adaptInvoiceRequestData(nullableValues), {
		signal,
	});

	if (!response || !response.data) {
		return response;
	}

	return {
		...response,
		data: response.data,
	};
};

export default patchInvoice;
